import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

import MyButton from '@common/components/Button/MyButton';
import { urlRegex } from '@common/helpers/helpers';

const LinkModal = ({ showModal, onOkClick, onCancelClick }) => {
  const [url, setUrl] = useState('');
  const [label, setLabel] = useState('');

  const { t } = useTranslation();

  useEffect(() => {
    if (showModal.show) {
      setUrl('');
      setLabel('');
    }
  }, [showModal.show]);

  const handleOk = () => {
    onOkClick({ url, label });
  };

  return (
    <Dialog fullWidth maxWidth='sm' open={showModal.show}>
      <DialogTitle>{t('modal_header')}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          required
          error={url !== '' && !urlRegex.test(url)}
          label={t('url')}
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          margin='dense'
        />
        <TextField
          required
          error={!label}
          fullWidth
          label={t('label')}
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          margin='dense'
        />
      </DialogContent>
      <DialogActions>
        <MyButton onClick={onCancelClick}>{t('cancel')}</MyButton>
        <MyButton
          color='primary'
          onClick={handleOk}
          disabled={!urlRegex.test(url) || !label}
        >
          {t('ok')}
        </MyButton>
      </DialogActions>
    </Dialog>
  );
};

export default LinkModal;
